import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiUsers } from "react-icons/fi";
import "./widgets.css";

const CollaborationOpportunitiesWidget = ({ opportunities }) => {
  const navigate = useNavigate();

  if (!opportunities || opportunities.length === 0) return null;

  const handleItemClick = (postId) => {
    navigate(`/posts/${postId}`);
  };

  return (
    <div className="cbx-widget cbx-widget--collab">
      <div className="cbx-widget__header">
        <h3 className="cbx-widget__title">
          <FiUsers className="cbx-widget__title-icon" />
          Collaborations
        </h3>
        <Link to="/collaborations" className="cbx-widget__see-all">
          See All
        </Link>
      </div>

      <div className="cbx-collab-list">
        {opportunities.slice(0, 3).map((opp) => {
          const positions = opp.collaboration?.positions || [];
          const totalSlots = positions.reduce((sum, p) => sum + (p.count || 0), 0);
          const filledSlots = positions.reduce((sum, p) => sum + (p.filled || 0), 0);

          return (
            <div
              key={opp._id}
              className="cbx-collab-item"
              onClick={() => handleItemClick(opp._id)}
            >
              <div className="cbx-collab-info">
                <h4 className="cbx-collab-title">
                  {opp.collaboration?.title || opp.content?.slice(0, 50) || "Collaboration Opportunity"}
                </h4>
                <span className="cbx-collab-author">
                  {opp.author?.name || "Unknown"}
                </span>
              </div>
              {totalSlots > 0 && (
                <span className="cbx-collab-slots">
                  {filledSlots}/{totalSlots}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CollaborationOpportunitiesWidget;

